import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    loading: true,
    data: [],
    error: [],
    total: 0,
    pageNo: 0,
    limit: 0,
    totalPage: 0
}

const teamListSlice = createSlice({
    name: 'teamList',
    initialState,
    reducers: {
        loaderListener: (state, action) => {
            state.loading = action.payload.loading;
        },
        successTeamListReducer: (state, action) => {
            state.loading = action.payload.loading;
            state.data = action.payload.data;
            state.total = action.payload.total;
            state.limit = action.payload.limit;
            state.pageNo = action.payload.pageNo;
            state.totalPage = action.payload.totalPage;
        },
        failedTeamListReducer: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
    }
});

export const { successTeamListReducer, failedTeamListReducer, loaderListener } = teamListSlice.actions;

export default teamListSlice.reducer;